import React from 'react'
import { ButtonType } from '../../../../components/GenericButton/styles'
import { Typography } from '@mui/material'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { DistributionManager } from '../../../../APIManager'
import { useTheme } from '@mui/material/styles'
import DefaultModalActions from '../../../../components/GenericModal/DefaultModalActions'
import { type ApiError } from '../../../../models/Common'
import { notification } from '../../../../components/Notifications'
import { grey } from '../../../../colors'
import { type ISlot } from '../../../../models/DistributionPlan'

interface DeleteDistributionPlanProps {
  selectedRow?: ISlot
  handleCloseModal?: () => void
  showErrorModal?: () => void
  setErrorMessage?: (arg: string) => void
  seriesId: string
}

const DeleteDistributionPlan: React.FC<DeleteDistributionPlanProps> = ({ selectedRow, handleCloseModal, showErrorModal, setErrorMessage }) => {
  const theme = useTheme()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async () => {
      if (!selectedRow?.slotId) return
      return await DistributionManager.deleteSlotBySlotId(selectedRow.slotId)
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['distributionPlan'] })
      notification(`Survey Project instance "${selectedRow?.term?.termName}" deleted successfully`, { variant: 'success' })
      handleCloseModal?.()
    },
    onError: (error: any) => {
      const customError = error as ApiError
      if (customError && customError.status === 422) {
        setErrorMessage?.(customError.message)
        showErrorModal?.()
        return
      }
      notification(customError?.message ?? 'Internal server error', { variant: 'error' })
    },
    meta: { silent: true }
  })

  const handleDelete = async (): Promise<void> => {
    mutation.mutate()
  }

  return (
    <>
      <Typography fontSize='14px' lineHeight={theme.spacing(5)} color={grey[850]}>
        You will not be able to recover this Survey Project. All references to it will be deleted.
      </Typography>
      <DefaultModalActions
        confirmButtonProps={{
          onClick: handleDelete,
          text: 'Delete',
          loading: mutation.isPending,
          buttonType: ButtonType.Destructive
        }}
        destructiveButtonProps={{
          onClick: handleCloseModal
        }}
      />
    </>

  )
}

export default DeleteDistributionPlan
